export const SET_PROFILE_MODAL = 'SET_PROFILE_MODAL'
export const RESET_PROFILE_MODAL = 'RESET_PROFILE_MODAL'
